import { tv } from 'tailwind-variants';

const styles = tv({
  slots: {
    box: `
      iris:group
      iris:font-(family-name:[unset])
      iris:size-(--comp-size-box-control-button)
      iris:cursor-pointer
      iris:gap-[unset]
      iris:rounded-(--comp-size-radius-control-button)
      iris:p-(--comp-space-padding-control-button-all)
      iris:duration-(--comp-motion-duration-control-button)
      iris:ease-(--comp-motion-easing-control-button)
    `,
    icon: `
      iris:size-(--comp-size-icon-control-button)
      iris:rounded-(--comp-size-radius-control-button)
      iris:p-[unset]
      iris:transition-all
      iris:duration-(--comp-motion-duration-control-button)
      iris:ease-(--comp-motion-easing-control-button)
    `
  },
  variants: {
    inverse: {
      true: {
        icon: `
          iris:bg-(--base-color-transparent)
          iris:text-(--comp-color-content-control-button-icon-inverse-rest)
          iris:group-hover:bg-(--base-color-transparent)
          iris:group-hover:text-(--comp-color-content-control-button-icon-inverse-hover)
          iris:group-focus:bg-(--base-color-transparent)
          iris:group-active:bg-(--base-color-transparent)
          iris:group-active:text-(--comp-color-content-control-button-icon-inverse-pressed)
        `
      },
      false: {
        icon: `
          iris:bg-(--base-color-transparent)
          iris:text-(--comp-color-content-control-button-icon-rest)
          iris:group-hover:bg-(--base-color-transparent)
          iris:group-hover:text-(--comp-color-content-control-button-icon-hover)
          iris:group-focus:bg-(--base-color-transparent)
          iris:group-active:bg-(--base-color-transparent)
          iris:group-active:text-(--comp-color-content-control-button-icon-pressed)
        `
      }
    }
  }
});

export { styles as default };
